import angular from 'angular';
import whatIsSolidaryCardComponent from './whatIsSolidaryCard.component';

let whatIsSolidaryCardModule = angular.module('whatIsSolidaryCard', [
])

.component('whatIsSolidaryCard', whatIsSolidaryCardComponent)

.name;

export default whatIsSolidaryCardModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryCard/whatIsSolidaryCard.js